export default __webpack_public_path__ + "static/nba-top-shot-d0f08155f517c41a23f3ddc89f099452.png";